import { useMemo, useContext, useState } from 'react';
import { useFormFields } from '../../hooks/useFormFields';
import MonoConnect from '@mono.co/connect.js';
import { Context as LoanContext } from '../../context/LoanContext';
import AuthWithMono from '../../components/MonoBtn';
import Statement from '../../components/Modal/Modal';
import { loanSchema } from '../../helpers/validator';
import './style.css';
import { toast } from 'react-toastify';
import VerifyBtn from '../../components/VerifyIdentityBtn';
import RequestBtn from '../../components/RequestBtn';
import {
  getExchangeToken,
  setValues,
  authAndGetLoan,
  selectUserData,
  selectMonoAuthStatus,
  verifiedIdentity,
  username,
  selectValues,
  selectState,
  selectLoanStatus,
} from './loanSlice';
import { useSelector, useDispatch } from 'react-redux';
import history from '../../history';

const Home = () => {
  const [firstBtnLoading, setFirstBtnLoading] = useState(false);
  const [accountActive, setAccountActive] = useState(true);
  const [loanActive, setLoanActive] = useState(false);
  const [prevView, setPrevView] = useState(true);

  let identityVerified = useSelector(verifiedIdentity);
  let userName = useSelector(username);
  let userData = useSelector(selectUserData);
  let values = useSelector(selectValues);
  let state = useSelector(selectState);
  let loanStatus = useSelector(selectLoanStatus);
  let monoAuthStatus = useSelector(selectMonoAuthStatus);

  // console.log({ state });
  const { amountToBorrow, interest, yearsInmonths } = values;

  const dispatch = useDispatch();

  const monoConnect = useMemo(() => {
    const monoInstance = new MonoConnect({
      onClose: () => console.log('Widget closed'),
      onLoad: () => {
        console.log('Widget loaded successfully');
      },
      onSuccess: async ({ code }) => {
        // console.log(`Linked successfully: ${code}`);
        // getMonoConnectKey(code);
        await dispatch(getExchangeToken(code, setFirstBtnLoading, handlePrev));
      },
      key: process.env.REACT_APP_MONO_PUBLIC_KEY,
    });

    monoInstance.setup();

    return monoInstance;
  }, []);

  const handleValues = (e, field) => {
    dispatch(setValues({ field, value: e.target.value }));
  };
  const handleAccountActive = () => {
    setLoanActive(false);
    setAccountActive(true);
  };

  const handleLoanActive = () => {
    setAccountActive(false);
    setLoanActive(true);
  };

  const handlePrev = () => {
    setPrevView(!prevView);
  };
  return (
    <>
      <div className="home">
        <div className="form">
          {prevView && (
            <>
              {' '}
              <h3 className={!identityVerified ? 'welcomeDisabled' : 'welcome'}>
                Welcome to Monomoney Loans!
              </h3>
              <h4 style={{ color: '#c4c4c4', textAlign: 'center' }}>
                Please fill the form to get started!
              </h4>
              <form>
                <div className="fieldLabel">
                  <label htmlFor="amountToBorrow">Amount</label>
                </div>
                <div className="nameField">
                  <input
                    value={amountToBorrow}
                    name="amountToBorrow"
                    onChange={(e) => handleValues(e, 'amountToBorrow')}
                    // disabled={!identityVerified}
                  />
                </div>
                <div className="fieldLabel">
                  <label htmlFor="interest">Interest(%)</label>
                  <label htmlFor="yearsInmonths">Payback Period (months)</label>
                </div>
                <div className="rateField">
                  <input value={interest} name="interest" disabled />
                  <input
                    value={yearsInmonths}
                    name="yearsInmonths"
                    onChange={(e) => handleValues(e, 'yearsInmonths')}
                    // disabled={!identityVerified}
                  />
                </div>
              </form>
              <div className="formFooterBtns">
                <AuthWithMono
                  onClick={() => monoConnect.open()}
                  loading={firstBtnLoading}
                />
              </div>
            </>
          )}
          {!prevView && (
            <>
              <div style={{ marginBottom: 12 }}>
                <button
                  className={`remove-btn-style  ${
                    accountActive && 'default-tab-color'
                  }`}
                  style={{ marginRight: 35 }}
                  onClick={() => handleAccountActive()}
                >
                  Account
                </button>
                <button
                  className="remove-btn-style tab-font-size"
                  onClick={() => handleLoanActive()}
                  style={{ marginLeft: 35 }}
                >
                  Loan Request Status
                </button>
              </div>
              {accountActive && (
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    padding: '10px',
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      margin: '20px 0px',
                      borderBottom: '1px dotted gray',
                    }}
                  >
                    <div>Account Currency</div>
                    <div style={{ color: '#0e175d', fontWeight: 700 }}>
                      {userData.account.currency}
                    </div>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      margin: '20px 0px',
                      borderBottom: '1px dotted gray',
                    }}
                  >
                    <div>Bank</div>
                    <div style={{ color: '#0e175d', fontWeight: 700 }}>
                      {userData.account.institution.name}
                    </div>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      margin: '20px 0px',
                      borderBottom: '1px dotted gray',
                    }}
                  >
                    <div>Account No.</div>
                    <div style={{ color: '#0e175d', fontWeight: 700 }}>
                      {userData.account.accountNumber}
                    </div>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      margin: '20px 0px',
                      borderBottom: '1px dotted gray',
                    }}
                  >
                    <div style={{ marginRight: 35 }}>Account Name</div>
                    <div style={{ color: '#0e175d', fontWeight: 700 }}>
                      {userData.account.name}
                    </div>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      margin: '20px 0px',
                      borderBottom: '1px dotted gray',
                    }}
                  >
                    <div>Balance</div>
                    <div style={{ color: '#0e175d', fontWeight: 700 }}>
                      {userData.account.balance}
                    </div>
                  </div>
                  <button
                    className="backBtn"
                    // style={{ marginRight: 35 }}
                    onClick={() => handlePrev()}
                  >
                    Back
                  </button>
                </div>
              )}
              {loanActive && (
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      margin: '20px 0px',
                      borderBottom: '1px dotted gray',
                    }}
                  >
                    <div style={{ marginRight: 35 }}>Recipient</div>
                    <div style={{ color: '#0e175d', fontWeight: 700 }}>
                      {userData.account.name}
                    </div>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      margin: '20px 0px',
                      borderBottom: '1px dotted gray',
                    }}
                  >
                    <div>Lender</div>
                    <div style={{ color: '#0e175d', fontWeight: 700 }}>
                      Monomoney
                    </div>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      margin: '20px 0px',
                      borderBottom: '1px dotted gray',
                    }}
                  >
                    <div>Loan Status</div>
                    <div
                      style={{
                        color: loanStatus ? `#0e175d` : 'red',
                        fontWeight: 700,
                      }}
                    >
                      {loanStatus ? 'Approved' : 'Rejected'}
                    </div>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      margin: '20px 0px',
                      borderBottom: '1px dotted gray',
                    }}
                  >
                    <div>Loan Amount</div>
                    <div style={{ color: '#0e175d', fontWeight: 700 }}>
                      {amountToBorrow}
                    </div>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      margin: '20px 0px',
                      borderBottom: '1px dotted gray',
                    }}
                  >
                    <div>Monthly Repayment</div>
                    <div style={{ color: '#0e175d', fontWeight: 700 }}>
                      {state.statement}
                    </div>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      margin: '20px 0px',
                      borderBottom: '1px dotted gray',
                    }}
                  >
                    <div>Payback Period</div>
                    <div style={{ color: '#0e175d', fontWeight: 700 }}>
                      {yearsInmonths} months
                    </div>
                  </div>
                  <button
                    className="backBtn"
                    // style={{ marginRight: 35 }}
                    onClick={() => handlePrev()}
                  >
                    Back
                  </button>
                </div>
              )}
            </>
          )}
        </div>

        {/* Second implementation of form*/}
        {/* <div className="form">
          <h3 className={!identityVerified ? 'welcomeDisabled' : 'welcome'}>
            Welcome {userName}!
          </h3>
          <h4>Find out if you're eligible for a loan!</h4>
          <form onSubmit={handleSubmit}>
            <div className="fieldLabel">
              <label htmlFor="amountToBorrow">Amount</label>
            </div>
            <div className="nameField">
              <input
                value={amountToBorrow}
                name="amountToBorrow"
                id="amountToBorrow"
                onChange={setValues}
                disabled={!identityVerified}
              />
            </div>
            <div className="fieldLabel">
              <label htmlFor="amountToBorrow">Interest(%)</label>
              <label htmlFor="amountToBorrow">Payback Period (months)</label>
            </div>
            <div className="rateField">
              <input value={interest} id="interest" disabled />
              <input
                value={yearsInmonths}
                id="yearsInmonths"
                onChange={setValues}
                disabled={!identityVerified}
              />
            </div>
          </form>
          <div className="formFooterBtns">
            <AuthWithMono
              onClick={() => monoConnect.open()}
              loading={firstBtnLoading}
            />
            <VerifyBtn
              monoAuthStatus={monoAuthStatus}
              secondBtnLoading={secondBtnLoading}
              onClick={() => handleIdentityVerification()}
            />
            <RequestBtn
              identityVerified={identityVerified}
              thirdBtnLoading={thirdBtnLoading}
              onClick={(e) => handleSubmit(e)}
            />
            <StatementBtn
              statementRecieved={statementRecieved}
              openModal={() => openModal()}
            />
          </div>
          <Statement
            modalIsOpen={modalIsOpen}
            closeModal={closeModal}
            amountToBorrow={amountToBorrow}
            yearsInmonths={yearsInmonths}
          />
        </div> */}
      </div>
    </>
  );
};

export default Home;

function StatementBtn({ statementRecieved, openModal }) {
  return (
    <button
      style={{ margin: 15 }}
      disabled={!statementRecieved}
      className={!statementRecieved ? 'requestBtnDisabled' : 'requestBtn'}
      onClick={openModal}
    >
      Open Statement
    </button>
  );
}
